var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ModalBase from "../../components/modalbase.vue";
import WizardContent from "../../components/wizard/wizardcontent.vue";
import { invalidMaterialWithGas, } from "../utilities/articleeditdata";
import { isAssembly, isManufacturablePart, isManufacturableSinglePart, } from "../utilities/documentdialog";
import { editStep, wsi4Data, } from "../utilities/wizard";
import { WorkStepType, } from "../utilities/wsi4_interfaces";
import { isNumber, isString, } from "../utilities/wsi4_typeguards";
let Wizard = class Wizard extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = "articleName";
        this.articleContents = [];
    }
    close() { }
    nextStep(s) {
        switch (s) {
            case "articleName": return this.showStep("thickness") ? "thickness" : "materialWithGas";
            case "thickness": return "materialWithGas";
            case "materialWithGas": return "multiplicity";
            case "multiplicity": return undefined;
        }
    }
    previousStep(s) {
        switch (s) {
            case "articleName": return undefined;
            case "thickness": return "articleName";
            case "materialWithGas": return this.showStep("thickness") ? "thickness" : "articleName";
            case "multiplicity": return "materialWithGas";
        }
    }
    alreadyDone(s) {
        const index = this.stepsShown.findIndex(step => step === s);
        if (index === -1) {
            throw Error("Step not shown.");
        }
        return index < this.currentIndex;
    }
    testId(s) {
        return s + "-step";
    }
    changePartInStep(step, v) {
        const a = this.projectEntries.find(a => a.vertexKey === v);
        if (a === undefined) {
            throw Error("Missing article");
        }
        return editStep(step, a);
    }
    showStep(step) {
        return this.vertexKeys.some(v => this.changePartInStep(step, v));
    }
    nextClicked() {
        const n = this.nextStep(this.currentStep);
        if (n !== undefined) {
            this.currentStep = n;
        }
        else {
            if (!this.networkBroker.queueChangeAttributesRequest(wsi4Data(this.articleContents, this.projectEntries, this.shopConfig))) {
                return;
            }
            if (!this.networkBroker.queueGraphRequest()) {
                return;
            }
            this.networkBroker.process();
            this.close();
        }
    }
    changeContent(newContent) {
        if (newContent.length !== this.articleContents.length) {
            throw Error("Content gone missing.");
        }
        this.articleContents = this.sortArticleContent(newContent);
        if (this.projectEntries.length !== this.articleContents.length) {
            throw Error("Content gone missing.");
        }
    }
    sortArticleContent(content) {
        return content.sort((a, b) => a.articleVertexKey < b.articleVertexKey ? -1 : (a.articleVertexKey === b.articleVertexKey ? 0 : 1));
    }
    valid(a, step) {
        switch (step) {
            case "articleName": {
                return isString(a.content.articleName) && a.content.articleName !== "";
            }
            case "thickness": {
                return true;
            }
            case "materialWithGas": {
                return !a.content.materialWithGas.invalid;
            }
            case "multiplicity": {
                return isNumber(a.content.multiplicity) && a.content.multiplicity > 0;
            }
        }
    }
    get stepsShown() {
        let currentStep = "articleName";
        const s = [];
        while (currentStep !== undefined) {
            s.push(currentStep);
            currentStep = this.nextStep(currentStep);
        }
        return s;
    }
    get currentIndex() {
        return this.stepsShown.findIndex(s => s === this.currentStep);
    }
    get invalidContents() {
        return this.articleContents.some(a => !this.valid(a, this.currentStep));
    }
    get projectEntries() {
        return [
            ...this.project.singleParts.filter(s => this.vertexKeys.some(v => s.vertexKey === v)),
            ...this.project.assemblies.filter(s => this.vertexKeys.some(v => s.vertexKey === v)),
        ];
    }
    created() {
        this.articleContents = this.sortArticleContent(this.projectEntries.map(entry => {
            const thickness = isManufacturableSinglePart(entry) && entry.lastWorkStepType !== WorkStepType.sheetBending ? entry.thickness : undefined;
            const thicknesses = (() => {
                if (isAssembly(entry)) {
                    return entry.parts.reduce((res, p) => {
                        if (isManufacturablePart(p)) {
                            return [
                                ...res,
                                p.thickness,
                            ];
                        }
                        return res;
                    }, []);
                }
                if (isManufacturableSinglePart(entry)) {
                    return [entry.thickness];
                }
                return [];
            })();
            return {
                articleVertexKey: entry.vertexKey,
                content: {
                    articleName: entry.articleName,
                    thickness: thickness,
                    materialWithGas: invalidMaterialWithGas(this.i18n),
                    multiplicity: entry.multiplicity,
                },
                png: entry.png,
                svg: entry.svg,
                thicknesses: thicknesses,
            };
        }));
    }
};
__decorate([
    Prop({ required: true })
], Wizard.prototype, "project", void 0);
__decorate([
    Prop({ required: true })
], Wizard.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], Wizard.prototype, "vertexKeys", void 0);
__decorate([
    Inject()
], Wizard.prototype, "i18n", void 0);
__decorate([
    Inject()
], Wizard.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], Wizard.prototype, "close", null);
Wizard = __decorate([
    Component({
        components: {
            ModalBase,
            WizardContent,
        },
        name: "Wizard",
    })
], Wizard);
export default Wizard;
